export default __webpack_public_path__ + "static/software-old-0540452d09abb1e5c05cffdc48fe1328.png";